// extracted by mini-css-extract-plugin
export default {"SyntheseConsultation":"SyntheseConsultation_SyntheseConsultation__UnVDh"};